export var _t = function (str) {
    var _a, _b, _c;
    // eslint-disable-next-line no-undef
    var namespace = __NAMESPACE__ !== null && __NAMESPACE__ !== void 0 ? __NAMESPACE__ : null;
    if ((_b = (_a = window.translations) === null || _a === void 0 ? void 0 : _a[namespace]) !== null && _b !== void 0 ? _b : false) {
        return (_c = window.translations[namespace][str]) !== null && _c !== void 0 ? _c : str;
    }
    return str;
};
